var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75033 13.2708H5.25033C2.08283 13.2708 0.729492 11.9175 0.729492 8.75V5.25C0.729492 2.08251 2.08283 0.729172 5.25033 0.729172H8.16699C8.40616 0.729172 8.60449 0.927505 8.60449 1.16667C8.60449 1.40584 8.40616 1.60417 8.16699 1.60417H5.25033C2.56116 1.60417 1.60449 2.56084 1.60449 5.25V8.75C1.60449 11.4392 2.56116 12.3958 5.25033 12.3958H8.75033C11.4395 12.3958 12.3962 11.4392 12.3962 8.75V5.83334C12.3962 5.59417 12.5945 5.39584 12.8337 5.39584C13.0728 5.39584 13.2712 5.59417 13.2712 5.83334V8.75C13.2712 11.9175 11.9178 13.2708 8.75033 13.2708Z",
    fill: "#E3E6F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 6.27083H10.5003C8.50533 6.27083 7.72949 5.495 7.72949 3.5V1.16667C7.72949 0.991665 7.83449 0.828332 7.99783 0.764165C8.16116 0.694165 8.34783 0.734999 8.47616 0.857499L13.1428 5.52417C13.2653 5.64667 13.3062 5.83917 13.2362 6.0025C13.1662 6.16583 13.0087 6.27083 12.8337 6.27083ZM8.60449 2.2225V3.5C8.60449 5.005 8.99533 5.39583 10.5003 5.39583H11.7778L8.60449 2.2225Z",
    fill: "#E3E6F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 8.02083H4.08301C3.84384 8.02083 3.64551 7.82249 3.64551 7.58333C3.64551 7.34416 3.84384 7.14583 4.08301 7.14583H7.58301C7.82217 7.14583 8.02051 7.34416 8.02051 7.58333C8.02051 7.82249 7.82217 8.02083 7.58301 8.02083Z",
    fill: "#E3E6F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41634 10.3542H4.08301C3.84384 10.3542 3.64551 10.1558 3.64551 9.91667C3.64551 9.67751 3.84384 9.47917 4.08301 9.47917H6.41634C6.65551 9.47917 6.85384 9.67751 6.85384 9.91667C6.85384 10.1558 6.65551 10.3542 6.41634 10.3542Z",
    fill: "#E3E6F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/documentText.68cd58294013e09a38855fbcacf393bd.svg";
export { ForwardRef as ReactComponent };